import { FontButtonGreyLightMedium } from '../../../utils/typografyApp';
import { Button } from './styled';

const PrimaryButton = ({children, onClick, disabled, type, className})=>{
    return(
        <Button 
            onClick={onClick} 
            disabled={disabled}
            type={type}
            className={className}
        >   
            <FontButtonGreyLightMedium>{children}</FontButtonGreyLightMedium>
        </Button>
    );
}

export default PrimaryButton;